import React from 'react';
import shortid from 'shortid';
import { FiFlag } from 'react-icons/fi';
import { FaChevronRight } from 'react-icons/fa';

const FlagsList = ({ list }) => {
  return (
    <div className="flags-beam result-list-single">
      <div className="row">
        {list &&
          list.map(item => (
            <div className="col-md-4" key={item}>
              <div className="flag-item">
                <div className="icon">
                  <FiFlag />
                </div>
                <div
                  key={shortid.generate()}
                  className="content"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

const DashList = ({ list, listHeader }) => {
  return (
    <div key={shortid.generate()} className="result-list-single">
      <div>
        {!!listHeader && <h3>{listHeader}</h3>}
        <ul key={shortid.generate()}>
          {list &&
            list.map(item => (
              <li
                key={shortid.generate()}
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: item }}
              />
            ))}
        </ul>
      </div>
    </div>
  );
};

const ParagraphsList = ({ list }) => {
  return (
    <div className="row">
      {list &&
        list.map(item => (
          <div className="col-md-6" key={item}>
            <div
              className="slab"
              key={shortid.generate()}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: item }}
            />
          </div>
        ))}
    </div>
  );
};

const ArrowsList = ({ list, listHeader }) => {
  return (
    <div className="dedic-list result-list-single">
      {!!listHeader && <h3>{listHeader}</h3>}
      <div className="row">
        {list &&
          list.map(item => (
            <div className="col-lg-4 col-md-6 dedic-item" key={item}>
              <div className="item-list">
                <div className="point">
                  <FaChevronRight />
                </div>
                <div
                  key={shortid.generate()}
                  className="body"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
const ArrowsListSecondary = ({ list, listHeader, imgPosition }) => {
  return (
    <div className="dedic-list result-list-single">
      {!!listHeader && <h3>{listHeader}</h3>}
      <div className="row">
        {list &&
          list.map(item => (
            <div
              className={`${
                imgPosition === 'Right' ? '' : 'col-lg-4 col-md-6'
                } dedic-item`}
              key={item}
            >
              <div className="item-list border-0">
                <div className="point">
                  <FaChevronRight />
                </div>
                <div
                  key={shortid.generate()}
                  className="body"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

const StepsList = ({ list, listHeader }) => {
  return (
    <div className="dedic-list numeric result-list-single">
      {!!listHeader && <h3>{listHeader}</h3>}
      <div className="row">
        {list &&
          list.map((item, itemIdx) => {
            const humanIdx = itemIdx + 1;
            const idxShow = humanIdx >= 10 ? humanIdx : `0${humanIdx}`;
            return (
              <div className="col-lg-4 col-md-6 dedic-item" key={item}>
                <div className="item-list">
                  <div className="point">{idxShow}</div>
                  <div
                    className="body"
                    key={shortid.generate()}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: item }}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const IconsList = ({ list, listHeader }) => {
  return (
    <div className="dedic-list numeric result-list-single">
      {!!listHeader && <h3>{listHeader}</h3>}
      <div className="row">
        {list &&
          list.map(item => {
            return (
              <div
                className="col-lg-3 col-md-6 dedic-item icons-center"
                key={item}
              >
                <div className="item-list px-3">
                  <div
                    className="item-img"
                    key={shortid.generate()}
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: item }}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const IconsListLeft = ({ list, listHeader }) => {
  return (
    <div className="dedic-list numeric result-list-single">
      {!!listHeader && <h3>{listHeader}</h3>}
      <div className="row">
        {list &&
          list.map(item => {
            return (
              <div className="col-md-6 dedic-item" key={item}>
                <div
                  className="icons-list-left "
                  key={shortid.generate()}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};
const IconsListThreeCol = ({ list, listHeader }) => {
  return (
    <div className="dedic-list numeric result-list-single">
      {!!listHeader && <h3>{listHeader}</h3>}
      <div className="row justify-content-between">
        {list &&
          list.map(item => {
            return (
              <div className="col-12 col-md-4 col-lg-3 dedic-item" key={item}>
                <div
                  className="icons-list-three-col"
                  key={shortid.generate()}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};

const ResultBaseSectionList = ({ list: item, imgPosition }) => {
  const { listHeader, list, listType } = item;
  if (listType === 'Flags') {
    return <FlagsList list={list} />;
  }
  if (listType === 'Dashes') {
    return <DashList list={list} listHeader={listHeader} />;
  }
  if (listType === 'Steps') {
    return <StepsList list={list} listHeader={listHeader} />;
  }
  if (listType === 'Arrows') {
    return <ArrowsList list={list} listHeader={listHeader} />;
  }
  if (listType === 'Arrows-without-border') {
    return (
      <ArrowsListSecondary
        imgPosition={imgPosition}
        list={list}
        listHeader={listHeader}
      />
    );
  }
  if (listType === 'Paragraphs') {
    return <ParagraphsList list={list} />;
  }
  if (listType === 'Icons-center') {
    return <IconsList list={list} />;
  }
  if (listType === 'Icons-left') {
    return <IconsListLeft list={list} />;
  }
  if (listType === 'Icons-three-col') {
    return <IconsListThreeCol list={list} />;
  }
  return <div />;
};

export default ResultBaseSectionList;
